import { useDispatch, useSelector } from 'react-redux';
import { BsInfoCircleFill } from "react-icons/bs";
import { isMobile } from 'react-device-detect';
import useGetMarketNameByMarketId from '../../../../CommonComponents/useGetMarketNameByMarketId';
import { useCallback, useState } from 'react';
import { CiCircleMinus, CiCirclePlus } from 'react-icons/ci';
import MarketCell from './MarketCell';
import { AnimatePresence, motion } from 'framer-motion';
import CashOutAura from '../../../components/CashoutAura';
import { handleOpenPlaceBet } from '../../../../AsianExchangeSrc/redux/slices/placeBetSlice';
import PlaceBet from '../../../components/PlaceBet';
import { sportsMapping } from './MatchDetailsBanner';
import { useSearchParams } from 'react-router-dom';
import { MdArrowRightAlt } from 'react-icons/md';
import { ImArrowRight } from "react-icons/im";

export function formatToKOrM(value) {
    if (!value) return value;
    if (value >= 1_000_000) {
        return (value / 1_000_000).toFixed(1) + 'M';
    } else if (value >= 1_000) {
        return (value / 1_000).toFixed(1) + 'K';
    } else {
        return value?.toFixed?.(1) ?? value;
    }
}

function BookMakerOdds() {

    const marketoddsData = useSelector(state => state?.bookmakerOdds?.bookMakerData?.data || []);
    const markets = useSelector(state => state?.marketOdds?.marketName || []);

    return (
        <div className="w-full flex flex-col">
            {
                Array.isArray(marketoddsData) && marketoddsData?.map((
                    market, i) => {
                    return (
                        <MarketContainer market={market} markets={markets} />

                    )
                })
            }
        </div>
    )
}

const MarketContainer = ({ market, markets }) => {
    const { marketId, totalMatched, runners: marketRunners, status: marketStatus, market: marketName } = market;
    // const { marketName } = useGetMarketNameByMarketId(marketId, markets);
    const [showMarket, setShowMarket] = useState(true);
    const [activeBet, setActiveBet] = useState(null);
    const [searchParams] = useSearchParams();
    const eventId = Number(searchParams.get("eventId"));
    const sportId = Number(searchParams.get("eventType"));

    const eventName = searchParams.get("eventName");
    const competitionId = Number(searchParams.get("competitionId"));

    const placedBets = useSelector(state => state.account.bets);
    const placedBetsInThisMarket = placedBets.filter(pb => pb?.marketId == marketId && pb.market == marketName && pb.event == eventName);

    return (

        <motion.div
            key={marketId}
            initial={{ height: 0, opacity: 0 }}
            animate={{ height: "auto", opacity: 1 }}
            exit={{ height: 0, opacity: 0 }}
            transition={{ duration: 0.1, ease: "easeInOut" }}
            className='shadow-sm '>
            {/* Row 1 */}
            <div className='w-full h-full flex flex-row items-center justify-between min-h-7 mt-2 border-b-[1px] border-[#7e97a7] bg-yellow-100 border-t-[0.3px] pr-2'>
                <div className='w-full flex flex-row flex-grow items-center'>
                    <span className="whitespace-nowrap min-h-7 flex flex-row gap-2 items-center justify-between text-center  pl-2 pr-2 py-1 rounded-tr-xl bg-aura-blue-gradient text-black dark:text-white text-xs font-semibold">{marketName}<BsInfoCircleFill /></span>
                    <span><CashOutAura /></span>
                    {/* <p>{marketStatus}</p> */}
                </div>
                <div className='flex flex-row items-center pr-2 whitespace-nowrap' >
                    <span className="text-[9px] font-extralight mr-1">
                        Matched
                    </span>
                    <span className="text-[10px] font-semibold">
                        &#8364;{formatToKOrM(totalMatched || 0)}
                    </span>
                </div>
                <div role="button" onClick={() => setShowMarket(prev => !prev)}
                    className="rounded-full bg-aura-blue-gradient text-black dark:text-white"
                >
                    {showMarket ? <CiCircleMinus size={18} /> : <CiCirclePlus size={18} />}
                </div>
            </div>

            {/* Dropdown Section with Framer Motion */}
            <AnimatePresence initial={false}>
                {showMarket && (
                    <motion.div
                        key="marketContent"
                        initial={{ height: 0, opacity: 0 }}
                        animate={{ height: "auto", opacity: 1 }}
                        exit={{ height: 0, opacity: 0 }}
                        transition={{ duration: 0.1, ease: "easeInOut" }}
                        className="overflow-hidden bg-yellow-100"
                    >
                        {/* Row 2 */}
                        <div className='w-full h-full flex flex-row items-center justify-between min-h-7 border-b-[1px] border-[#7e97a7] bg-yellow-100 border-t-[0.3px]'>
                            <div className={`flex flex-grow w-[${isMobile ? "65%" : "30%"}] min-h-7 py-1 pl-2 pr-1`} >
                                <div className='min-h-5 flex flex-row items-center h-full bg-light-bg tex-black dark:text-white rounded-sm py-1 px-3 whitespace-nowrap text-[9px]'>
                                    Min Max &nbsp; <span className='text-10px font-semibold'> {`${formatToKOrM(50) || "50"} - ${formatToKOrM(10000) || "10k"}`}</span>
                                </div>
                            </div>
                            <div className={`flex flex-row flex-grow w-[${isMobile ? "35%" : "70%"}]  min-h-7`}>
                                <div className={`w-full flex flex-grow basis-[${isMobile ? 1 / 2 : 1 / 6}%] min-h-7 ${isMobile ? "bg-[#72BBEF]" : "bg-gradient-to-r from-[#D7E8F4] to-[#72BBEF]"} rounded-tl-md text-xs font-semibold mt-1 items-center justify-center`}>
                                    Back
                                </div>
                                <div className={`w-full flex flex-grow basis-[${isMobile ? 1 / 2 : 1 / 6}%] min-h-7 ${isMobile ? "bg-[#FAA9BA]" : "bg-gradient-to-r from-[#FAA9BA] to-[#F6E6EA]"} rounded-tr-md text-xs font-semibold mt-1 items-center justify-center`}>
                                    Lay
                                </div>
                            </div>
                        </div>

                        {/* Row 3 */}
                        {
                            marketRunners?.map((runner) => {
                                let marketRunnerData = markets.find(m => m.marketId === marketId)
                                let runnerData = marketRunnerData?.runners.find(r => r.selectionId === runner.selectionId)

                                return (
                                    <MarketRunnerContainer placedBetsInThisMarket={placedBetsInThisMarket} marketName={marketName} marketId={marketId} runner={runner} runnerData={runnerData} marketRunners={marketRunners} setActiveBet={setActiveBet} activeBet={activeBet} />
                                );
                            })
                        }
                    </motion.div>
                )}
            </AnimatePresence>
        </motion.div>
    );
};

export const MarketRunnerContainer = ({placedBetsInThisMarket, marketName, marketId, runner, runnerData, marketRunners, setActiveBet, activeBet }) => {
    const dispatch = useDispatch();
    const [searchParams] = useSearchParams();
    const sportId = Number(searchParams.get("eventType"));
    const eventId = Number(searchParams.get("eventId"));

    const competitionId = Number(searchParams.get("competitionId"));

    const [selfSelectedOdds, setSelfSelectedOdds] = useState(0)

    // const handleMarketCellClick = (betBoxBgColor, price) => {
    //     setSelfSelectedOdds(price);
    //     dispatch(handleOpenPlaceBet({
    //         sportName: sportsMapping[sportId], sportId: sportId, competitionId, marketId, selectionId: runner.selectionId, betBoxBgColor
    //     }))
    // }
    const handleMarketCellClick = (betBoxBgColor, price, betType) => {
        setSelfSelectedOdds(price);
        dispatch(handleOpenPlaceBet({
            sportName: sportsMapping[sportId], sportId: sportId, competitionId, marketId, market: marketName, markettype: "Bookmaker", selectionId: runner.selectionId, betBoxBgColor, betType
        }))
    }

    const calculateBetValues = useCallback(
        (runner, marketId) => {
            const filteredBets = placedBetsInThisMarket || [];

            const fbOfThisRunner =
                filteredBets?.filter(
                    (fb) =>
                        fb.selectionId.toString() === runner.selectionId.toString() &&
                        eventId.toString() === fb.matchId.toString() &&
                        fb.marketId === marketId
                ) || [];

            const fbOfOtherRunners =
                filteredBets?.filter(
                    (fb) =>
                        fb.selectionId.toString() !== runner.selectionId.toString() &&
                        eventId.toString() === fb.matchId.toString() &&
                        fb.marketId === marketId
                ) || [];

            let placedBetCalculation =
                fbOfThisRunner.reduce(
                    (acc, fbr) =>
                        acc + (fbr.type === "Back" ? fbr.favourMargin : -fbr.againstMargin),
                    0
                ) +
                fbOfOtherRunners.reduce(
                    (acc, fbor) =>
                        acc +
                        (fbor.type === "Back" ? -fbor.againstMargin : fbor.favourMargin),
                    0
                );

            return placedBetCalculation;
        },
        [placedBetsInThisMarket, eventId]
    );

    const placedBetCalculation = calculateBetValues(runner, marketId);

    const newCalc = activeBet && runner?.selectionId === activeBet?.selectionId ?
        activeBet?.favourMargin.toFixed(1) : activeBet?.againstMargin.toFixed(1)
    return (
        <div key={runner.selectionId} className="relative w-full bg-yellow-100">
            <div className='w-full flex items-stretch justify-between min-h-11 border-b-[1px] border-[#7e97a7] bg-yellow-100 border-t-[0.3px]'>

                {/* Runner Column */}
                <div className={`flex flex-col justify-center w-[${isMobile ? "65%" : "30%"}] pl-2 pr-1 py-1`}>
                    <p className='text-[13px] font-semibold text-black '>{runnerData?.runnerName || runner?.runner || "unknown"}</p>
                    {/* {activeBet && newCalc && <p className={`flex flex-row items-center text-[10px] font-semibold ${newCalc>0 ? "text-green-600": "text-red-500"}`}> <span> <ImArrowRight className='mr-1' /> </span> {Math.abs(newCalc)} </p>} */}
                    <div className='flex flex-row items-center'>

                        {placedBetCalculation !== 0 && <p className={`flex flex-row items-center text-[10px] font-semibold ${placedBetCalculation > 0 ? "text-green-600" : "text-red-500"}`}> <span> <ImArrowRight className='mr-1' /> </span> {Math.abs(placedBetCalculation.toFixed(0))} </p>}
                        {activeBet && newCalc && <p className={`flex flex-row items-center text-[10px] font-semibold ${placedBetCalculation === 0 ? "" : "ml-2"} ${(Number(newCalc || 0) + (Number(placedBetCalculation) || 0)) > 0 ? "text-green-600" : "text-red-500"}`}> <span> <ImArrowRight className='mr-1' /> </span> {Math.abs(((Number(newCalc) + (Number(placedBetCalculation) || 0))).toFixed(0))} </p>}

                    </div>
                </div>

                {/* MarketCell Column */}

                <div className={`${runner.status.toLowerCase() != "active" ? "aura-suspended" : ""} flex flex-wrap flex-grow w-[${isMobile ? "35%" : "70%"}]`}
                    data-label={runner.status.toLowerCase() != "active" ? (runner?.status || "Suspended") : ""}
                >
                    {!isMobile && <MarketCell handleMarketCellClick={handleMarketCellClick} price={runner?.ex?.availableToBack?.[2]?.price} size={runner?.ex?.availableToBack?.[2]?.size} bgColor="#D7E8F4" hideOnMobile betType="Back" />}
                    {!isMobile && <MarketCell handleMarketCellClick={handleMarketCellClick} price={runner?.ex?.availableToBack?.[1]?.price} size={runner?.ex?.availableToBack?.[1]?.size} bgColor="#B7D5EB" hideOnMobile betType="Back" />}
                    <MarketCell handleMarketCellClick={handleMarketCellClick} price={runner?.ex?.availableToBack?.[0]?.price} size={runner?.ex?.availableToBack?.[0]?.size} bgColor="#72BBEF" betType="Back" />
                    <MarketCell handleMarketCellClick={handleMarketCellClick} price={runner?.ex?.availableToLay?.[0]?.price} size={runner?.ex?.availableToLay?.[0]?.size} bgColor="#FAA9BA" betType="Lay" />
                    {!isMobile && <MarketCell handleMarketCellClick={handleMarketCellClick} price={runner?.ex?.availableToLay?.[1]?.price} size={runner?.ex?.availableToLay?.[1]?.size} bgColor="#EFD3D9" hideOnMobile betType="Lay" />}
                    {!isMobile && <MarketCell handleMarketCellClick={handleMarketCellClick} price={runner?.ex?.availableToLay?.[2]?.price} size={runner?.ex?.availableToLay?.[2]?.size} bgColor="#F6E6EA" hideOnMobile betType="Lay" />}
                </div>

            </div>

            {/* <PlaceBet
                sportName={sportsMapping[sportId]}
                sportId={sportId}
                competitionId={competitionId}
                marketId={marketId}
                selectionId={runner.selectionId}
                selectedOdds={selfSelectedOdds}
            /> */}

            <PlaceBet
                sportName={sportsMapping[sportId]}
                sportId={sportId}
                competitionId={competitionId}
                marketId={marketId}
                market={marketName}
                markettype="Bookmaker"
                selectionId={runner.selectionId}
                selection={runner?.runner}
                selectedOdds={selfSelectedOdds}
                setActiveBet={setActiveBet}
                suspendNow={`${runner.status.toLowerCase() != "active" ? "aura-suspended" : ""}`}
                runners={marketRunners.map(({ runner: r, selectionId: sid }) => { return { runner: r, selectionId: sid } })}

            />

        </div>
    )
}

export default BookMakerOdds

